import React from "react";
import { Button } from "../button";
import { HiDownload } from "react-icons/hi";
import styled from "styled-components";

const StyledDownload = styled(HiDownload)`
  position: relative;
  top: 4px;
`;

let StyledShareButton = styled(Button)``;

export default function DownloadClip({
  classification,
  onClick,
  size,
  hideOnMobile,
  ...props
}) {
  classification = classification ? classification : "secondary";
  return (
    <StyledShareButton
      hideOnMobile={hideOnMobile}
      title="Create Mobile Clip"
      size={size}
      classification={classification}
      flex={true}
      justifyContent="center"
      alignIContent="center"
      onClick={(e) => {
        onClick && onClick(e);
      }}
      {...props}
    >
      <StyledDownload size={20}></StyledDownload>
      {props.children}
    </StyledShareButton>
  );
}
